export class CommonSelectedData{

  public selectedId: string;
  public selectedName: string;

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/data/common-selected-data.ts